import { OptionKey } from '@common-fe/common-fe';

import {
  ReportSummaryRequestBaseParams,
  ReportTableRequestBaseParams,
} from '../ReportSummary/ReportSummary.types';

export const LAST_30_DAYS_KEY = 'LAST_30_DAYS';
export const LAST_7_DAYS = 'LAST_7_DAYS';
export interface CardStatusSummaryReportParams extends ReportSummaryRequestBaseParams {
  cardStatusGroupType: OptionKey;
}
export interface CardStatusReportTableParams extends ReportTableRequestBaseParams {
  isSSNShowed: boolean;
  cardStatuses: OptionKey[];
  employmentStatuses: OptionKey[];
  mailedStartDate: Date | null;
  mailedEndDate: Date | null;
}
